import { Fit, isGiphyUrl, Transformers } from "@seneca/image-service-client";

import { Image } from "common/types/images";

import { getClient } from "services";

import { AssetParameters } from "seneca-common/features/module/module-types/types";

export const transformCdnImageUrl = <T extends string | null | undefined>(
  url?: T,
  assetParameters?: AssetParameters
) =>
  url
    ? getClient("imageService").getImageUrl(
        url,
        assetParameters as Transformers
      )
    : url;

export const getCdnImageDetails = (
  url: string | Image | null | undefined,
  assetParameters: AssetParameters
): Image => {
  const imageUrl = url && (typeof url === "string" ? url : url.url);

  if (!imageUrl) {
    return {
      url: imageUrl
    };
  }

  const isGiphyLink = isGiphyUrl(imageUrl);
  const transformedUrl = transformCdnImageUrl(imageUrl, assetParameters);

  // Use the giphy link by default, if that fails to load fallback to the seneca gif cdn link
  return {
    url: isGiphyLink ? imageUrl : transformedUrl,
    fallbackUrl: isGiphyLink ? transformedUrl : null
  };
};

export const MAX_IMAGE_WIDTH = 512;
export const MAX_IMAGE_HEIGHT = Math.round(MAX_IMAGE_WIDTH * 1.5);

export const assetParameters = {
  width: MAX_IMAGE_WIDTH,
  height: MAX_IMAGE_HEIGHT,
  fit: Fit.INSIDE
};

export function transformImageUrlWithDefaultParams(
  url: string,
  params: AssetParameters = assetParameters
) {
  return transformCdnImageUrl(url, assetParameters);
}
